import React from 'react'
import { useStaticQuery, graphql, Link } from 'gatsby'
import Helmet from 'react-helmet'
import Layout from '../../components/Layout'
import ServiceFooter from '../../components/ServiceFooter'

import { softwareServiceItems } from '../../serviceCategories'
import ServiceMenuItem from '../../components/ServiceMenuItem'

const Remote = () => {
  const {
    site: {
      siteMetadata: { title },
    },
  } = useStaticQuery(graphql`
    {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <Layout>
      <Helmet>
        <html className="temp" lang="ja" />
        <title>{`ソフトウェア | ${title}`}</title>
        <meta
          name="description"
          content="アイテックのソフトウェアはデータとAIで運営を効率化、高度化し、駐車場特有の課題を解決します"
        />
      </Helmet>

      <div className="common-header clearfix">
        <p className="category pc-only">製品・サービス</p>
        <h1>ソフトウェア</h1>
        <p className="category sp-only">製品・サービス</p>

        <div className="breadcrumb">
          <li>
            <Link to={`/`}>トップページ</Link>
          </li>
          /
          <li>
            <Link to={`/service`}>製品・サービス</Link>
          </li>
          /<li>ソフトウェア</li>
        </div>
      </div>

      <div className="main-wrapper middle-toppage software">
        <div className="row">
          <div className="container empty"></div>
        </div>

        <div className="row">
          <div className="h-wrapper">
            <h2>アイテックのソフトウェア</h2>
          </div>
        </div>

        <div className="row">
          <div className="container top">
            <h4>データとAIで運営を効率化、高度化し、駐車場特有の課題を解決</h4>

            <p>
              現場管理からデータ活用まで、持続可能な運営モデルの構築を支援します。
            </p>

            <h5>
              ITC
              パーキングソリューションで運営会社様の要望に沿った、スマートパーキングを実現
            </h5>

            <img
              className="big-picture pc-only"
              src="/img/parking-solution.svg"
              alt="駐車場データAPIを利用した集客支援・開発支援・キャッシュレス導入支援・管理運営DX支援"
            />
            <div className="parking-data-api-network sp-only">
              <img
                className="center"
                src="/img/parkingdata-api.png"
                alt="駐車場データAPIを利用した集客支援・開発支援・キャッシュレス導入支援・管理運営DX支援"
              />
              <div className="card">
                <div className="card-header">集客支援</div>
                <div className="card-body">
                  <div>
                    <h5>アイテック提供駐車場アプリ(QT-net サービス)</h5>
                    <p>
                      QT-net 個人会員サービス、QT-net
                      法人会員サービスが利用可能。検索・予約・ポイント・スマホ精算・車番登録によるシームレス決済など駐車場の利便性を向上。
                    </p>
                  </div>
                  <div>
                    <h5>地図アプリ連携</h5>
                    <p>Google Maps・Navitimeなどとの連携が可能。</p>
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="card-header">開発支援</div>
                <div className="card-body">
                  <div>
                    <h5>運営会社様開発アプリとの連携</h5>
                    <p>
                      アプリやカーナビで、駐車場情報・満空情報・決済機能などが連携可能。
                    </p>
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="card-header">キャッシュレス導入支援</div>
                <div className="card-body">
                  <div>
                    <h5>主要決済ツールの導入</h5>
                    <p>
                      QRコード・クレジットカード・dポイント・SmooPAなどが利用可能。
                    </p>
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="card-header">管理・運営DX支援</div>
                <div className="card-body">
                  <div>
                    <h5>現場管理DX</h5>
                    <p>i-BARMS</p>
                  </div>
                  <div>
                    <h5>収益向上・運営効率化</h5>
                    <p>
                      i-BARMS
                      PROでの、データ分析・もっともうかるくん・周辺現場速報・売上予測AI・公図変換機能・ジャーナル読み取りAIなど。
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row bottom">
          <div className="container top">
            <h5>関連ページ</h5>
            <div className="service-mega__items">
              {softwareServiceItems?.map((item) => (
                <ServiceMenuItem
                  key={`software-${item.to || item.href || 'noop'}`}
                  item={item}
                />
              ))}
            </div>
          </div>
        </div>

        <ServiceFooter />
      </div>
    </Layout>
  )
}

export default Remote
